import { Component, inject, output } from '@angular/core';
import { ElementRef } from '@angular/core';
import { ElementsType } from '../../../../state-management/model/enums/state.enums';
import { MetaConfigComponent } from '../meta-config/meta-config.component';
import { META_CONFIG_DATA } from '../editable-text/editable-text.component';

export interface MetaConfigDialogData {
  elemId: string;
  styleId: string | null;
  CSDElementRef: ElementRef | null;
  eType: ElementsType;
}

@Component({
  selector: 'app-meta-config-dialog',
  standalone: true,
  imports: [MetaConfigComponent],
  templateUrl: './meta-config-dialog.component.html',
  styleUrl: './meta-config-dialog.component.scss'
})
export class MetaConfigDialogComponent {
  readonly data: MetaConfigDialogData = inject(META_CONFIG_DATA);
  readonly closePanel = output<void>();

  public onClose(): void {
    this.closePanel.emit();
  }
}